import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { ExpozorTable } from './components';
import { ExpozorHeader } from './components';
import { ExpozorFooter } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  }
}));

const ExpozorList = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {/* <ExpozorHeader/> */}
      <ExpozorTable/>
      <ExpozorFooter/>
      {/* <div style={{color:'grey', marginTop:'15px'}}>
        <p>*)pret de catalog orientativ. Poate varia marginal in functie de cursul valutar de la data comenzii.</p>
        <p>**)Produs similar ca tip, culoare, material si optionale. Nu se preiau cotele.</p>
      </div> */}
    </div>
    
  );
};

export default ExpozorList;

